<!-- Icons POC -->
<script lang="ts">
  import type { ComponentType } from 'svelte';
  import { icons, type IconName } from './index';

  export let icon: IconName;

  $: component = icons[icon] as ComponentType;
</script>

<svelte:component
  this={component}
  class="h-4 w-4 {$$props.class}"
  stroke="currentColor"
  fill="none"
  {...$$props}
/>
